module.exports = __webpack_public_path__ + "static/christian_sec4-10ec54fd789bd6f1f851a1703ecf7413.png";